module.exports = __webpack_public_path__ + "img/vacinas_sem_cadastro.667e905f.png";